import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DropdownOption } from '../custom-dropdown/custom-dropdown.component';

@Component({
  selector: 'hmt-job-plan-order-sorting',
  templateUrl: './job-plan-order-sorting.component.html',
  styleUrls: ['./job-plan-order-sorting.component.scss'],
  standalone: false
})
export class JobPlanOrderSortingComponent {
  /** Gates the Select All row — pointless with no rows on screen to select. */
  @Input() hasOrders = false;
  /**
   * Gates the Sort By / Group By / Other Filters toolbar. Separate from `hasOrders` because a
   * filtered zero-result still needs these controls reachable — they are what the user adjusts to
   * get their orders back.
   */
  @Input() showControls = false;
  @Input() sortBy: 'totalVolume' | 'totalWeight' | 'consigneeName' = 'totalVolume';
  @Input() sortOrder: 'ascending' | 'descending' = 'ascending';
  @Input() groupBy: 'none' | 'consigneeName' | 'dropOffLocationName' = 'none';
  @Input() activeFiltersCount = 0;
  @Input() selectAllChecked = false;
  @Input() selectAllIndeterminate = false;
  @Input() hideCheckboxes = false;
  @Output() sortByChange = new EventEmitter<'totalVolume' | 'totalWeight' | 'consigneeName'>();
  @Output() sortOrderChange = new EventEmitter<'ascending' | 'descending'>();
  @Output() groupByChange = new EventEmitter<'none' | 'consigneeName' | 'dropOffLocationName'>();
  @Output() openFilters = new EventEmitter<Event>();
  @Output() selectAllChange = new EventEmitter<boolean>();

  @ViewChild('otherFiltersBtn', { static: false }) otherFiltersBtn!: ElementRef<HTMLButtonElement>;

  sortByOptions: DropdownOption[] = [
    { value: 'totalVolume', label: 'Volume' },
    { value: 'totalWeight', label: 'Weight' },
    { value: 'consigneeName', label: 'Consignee Name' }
  ];

  sortOrderOptions: DropdownOption[] = [
    { value: 'ascending', label: 'Ascending' },
    { value: 'descending', label: 'Descending' }
  ];

  groupByOptions: DropdownOption[] = [
    { value: 'none', label: 'None' },
    { value: 'consigneeName', label: 'Consignee' },
    { value: 'dropOffLocationName', label: 'Drop Off Location' }
  ];

  onSortByChange(): void {
    this.sortByChange.emit(this.sortBy);
  }

  onSortOrderChange(): void {
    this.sortOrderChange.emit(this.sortOrder);
  }

  onGroupByChange(): void {
    this.groupByChange.emit(this.groupBy);
  }

  onOpenFilters(event: Event): void {
    this.openFilters.emit(event);
  }
}

